export { achievementsWithTemplateSupport } from './achievementsWithTemplateSupport';
export { extraAiFeatures } from './extraAiFeatures';
export { filterValuesSeparator } from './filterValuesSeparator';
export { filterValuesSeparatorSplitRegex } from './filterValuesSeparatorSplitRegex';
export { supportedFormHelpTextOptionsKeys } from './supportedFormHelpTextOptionsKeys';
export { default as taskBlockTypes } from './blockTaskTypes';

// export the block data information
import {
  blockAudioData,
  defaults as audioDefaults
} from './defaultBlockDataAudio';
import {
  blockDiscussionData,
  defaults as discussionDefaults
} from './defaultBlockDataDiscussion';
import {
  blockEmbedData,
  defaults as embedDefaults
} from './defaultBlockDataEmbed';
import {
  blockFileData,
  defaults as fileDefaults
} from './defaultBlockDataFile';
import {
  blockFillinData,
  defaults as fillinDefaults
} from './defaultBlockDataFillin';
import { blockH5PData, defaults as h5pDefaults } from './defaultBlockDataH5P';
import {
  blockHeadingData,
  defaults as headingDefaults
} from './defaultBlockDataHeading';
import {
  blockImageData,
  defaults as imageDefaults
} from './defaultBlockDataImage';
import {
  blockLikertData,
  defaults as likertDefaults
} from './defaultBlockDataLikert';
import {
  blockListData,
  defaults as listDefaults
} from './defaultBlockDataList';
import {
  blockMathjaxData,
  defaults as mathjaxDefaults
} from './defaultBlockDataMathjax';
import {
  blockMultipleChoiceData,
  defaults as multipleChoiceDefaults
} from './defaultBlockDataMultipleChoice';
import {
  blockNumericQuestionData,
  defaults as numericQuestionDefaults
} from './defaultBlockDataNumericQuestion';
import {
  blockOpenQuestionData,
  defaults as openQuestionDefaults
} from './defaultBlockDataOpenQuestion';
import {
  blockPageBreakData,
  defaults as pageBreakDefaults
} from './defaultBlockDataPageBreak';
import { blockPreData, defaults as preDefaults } from './defaultBlockDataPre';
import {
  blockQuoteData,
  defaults as quoteDefaults
} from './defaultBlockDataQuote';
import { blockRawData, defaults as rawDefaults } from './defaultBlockDataRaw';
import {
  blockScormData,
  defaults as scormDefaults
} from './defaultBlockDataScorm';
import {
  blockSequencingData,
  defaults as sequencingDefaults
} from './defaultBlockDataSequencing';
import {
  blockSingleChoiceData,
  defaults as singleChoiceDefaults
} from './defaultBlockDataSingleChoice';
import {
  blockTableData,
  defaults as tableDefaults
} from './defaultBlockDataTable';
import {
  blockTextData,
  defaults as textDefaults
} from './defaultBlockDataText';
import {
  blockVideoData,
  defaults as videoDefaults
} from './defaultBlockDataVideo';

export const blockDataByBlockType = {
  audio: blockAudioData,
  discussion: blockDiscussionData,
  embed: blockEmbedData,
  file: blockFileData,
  fillin: blockFillinData,
  h5p: blockH5PData,
  heading: blockHeadingData,
  image: blockImageData,
  likert: blockLikertData,
  list: blockListData,
  mathjax: blockMathjaxData,
  multiplechoice: blockMultipleChoiceData,
  numericquestion: blockNumericQuestionData,
  openquestion: blockOpenQuestionData,
  pagebreak: blockPageBreakData,
  pre: blockPreData,
  quote: blockQuoteData,
  raw: blockRawData,
  scorm: blockScormData,
  sequencing: blockSequencingData,
  singlechoice: blockSingleChoiceData,
  table: blockTableData,
  text: blockTextData,
  video: blockVideoData
};

export const defaultsByBlockType = {
  audio: audioDefaults,
  discussion: discussionDefaults,
  embedcode: embedDefaults,
  embedlink: embedDefaults,
  file: fileDefaults,
  fillin: fillinDefaults,
  h5p: h5pDefaults,
  heading: headingDefaults,
  image: imageDefaults,
  likert: likertDefaults,
  list: listDefaults,
  mathjax: mathjaxDefaults,
  multiplechoice: multipleChoiceDefaults,
  numericquestion: numericQuestionDefaults,
  openquestion: openQuestionDefaults,
  pagebreak: pageBreakDefaults,
  pre: preDefaults,
  quote: quoteDefaults,
  raw: rawDefaults,
  scorm: scormDefaults,
  sequencing: sequencingDefaults,
  singlechoice: singleChoiceDefaults,
  table: tableDefaults,
  text: textDefaults,
  video: videoDefaults
};
